import { render, staticRenderFns } from "./LinkActions.vue?vue&type=template&id=dfba0b00&scoped=true&"
import script from "./LinkActions.vue?vue&type=script&lang=ts&"
export * from "./LinkActions.vue?vue&type=script&lang=ts&"
import style0 from "./LinkActions.vue?vue&type=style&index=0&id=dfba0b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfba0b00",
  null
  
)

export default component.exports